import {FEATURE_FLAGS} from '../../../constants';
import {hasFeatureFlag} from './FeatureUtil';
import {isJiraCustomer} from './JiraUtil';

/**
 * Matches the runtime contract of {@link isJiraCustomer}: Relay-generated
 * company types have nullable fields, and the company itself may be missing.
 */
type JiraFlaggedCompany = {jiraCloudEnabled?: boolean | null; jiraServerEnabled?: boolean | null} | null | undefined;

/**
 * Whether the task-modal *description* should render with the new Plate JS
 * editor rather than the legacy DraftJS editor.
 *
 * Gated by the `plate_js_task_modal` feature flag, but Jira customers are
 * explicitly carved out and stay on the legacy editor even when the flag is on
 * (PIKA-541) — the legacy editor is the one that stays compatible with
 * Jira-synced content.
 */
export const shouldUsePlateTaskEditor = (company: JiraFlaggedCompany): boolean =>
	hasFeatureFlag(FEATURE_FLAGS.PLATE_JS_TASK_MODAL) && !isJiraCustomer(company);

/**
 * Whether task-modal *comments* should render with the new Plate JS editor
 * rather than the legacy DraftJS editor.
 *
 * Gated by the `plate_js_task_modal_comments` feature flag, with the same Jira
 * customer carve-out as {@link shouldUsePlateTaskEditor} (PIKA-541).
 */
export const shouldUsePlateCommentEditor = (company: JiraFlaggedCompany): boolean =>
	hasFeatureFlag(FEATURE_FLAGS.PLATE_JS_TASK_MODAL_COMMENTS) && !isJiraCustomer(company);
